import { Component } from '@angular/core';
import { BannerComponent } from '../components/banner/banner.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-ended',
  standalone: true,
  imports: [BannerComponent, TranslatePipe],
  templateUrl: './ended.component.html',
  styleUrl: './ended.component.scss'
})
export class EndedComponent {

  ngOnInit() {
    document.getElementById("ended-header")?.focus()
  }
}
